module.exports = __webpack_public_path__ + "img/bookmark.440d73ce.svg";